import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'
import Modal from '@divvy-web/skylab.modal'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { URL } from '@sputnik/resources/constants'

interface ExperianModalProps {
  isShowing: boolean
  onCloseClick: () => void
}

const ExperianModal = ({ isShowing, onCloseClick }: ExperianModalProps) => {
  const navigateToExperianFreezeCenter = () => {
    window.open(URL.EXPERIAN_FREEZE_CENTER, '_blank', 'noopener, noreferrer')
  }

  const learnMoreLink = () => {
    window.open(URL.EXPERIAN_LEARN_MORE, '_blank', 'noopener, noreferrer')
  }

  return (
    <Modal
      actions={
        <>
          <BasicButton
            key='learn-more'
            type={BASIC_BUTTON_TYPE_FLAT}
            onClick={learnMoreLink}
          >
            <FormattedMessage
              defaultMessage='Learn more'
              id='sputnik.ExperianModal__TdTXXf'
            />
          </BasicButton>
          <BasicButton onClick={navigateToExperianFreezeCenter}>
            <FormattedMessage
              defaultMessage='Go to Experian'
              id='sputnik.ExperianModal__OF1DEA'
            />
          </BasicButton>
        </>
      }
      isShowing={isShowing}
      title={
        <FormattedMessage
          defaultMessage='Contact Experian'
          id='sputnik.ExperianModal__PnveGM'
        />
      }
      onCloseClick={onCloseClick}
    >
      <FormattedMessage
        defaultMessage='We use Experian to run all credit. The best way to unfreeze your credit is to visit the Experian {experianLink} and submit a request to remove the freeze. Removing a credit freeze can take up to 6 hours to process.'
        id='sputnik.ExperianModal__8omSup'
        values={{
          experianLink: (
            <TextLink
              size={TextLinkSizes.REGULAR}
              onClick={navigateToExperianFreezeCenter}
            >
              <FormattedMessage
                defaultMessage='security freeze center'
                id='sputnik.ExperianModal__xUwWNg'
              />
            </TextLink>
          ),
        }}
      />
    </Modal>
  )
}

export default ExperianModal
